import { Flex, Text } from '@chakra-ui/react';
import CardMy from 'components/CardMy';
import Loader from 'components/Loader';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { fetchTeams, selectTeamsIsLoading, selectTeamsLength } from 'store/slices/teams';
import CreateTeamDialog from './CreateTeamDialog';
import TeamTable from './TeamTable';

const Team = () => {
    const dispatch = useAppDispatch();
    const loading = useAppSelector(selectTeamsIsLoading);
    const teams = useAppSelector(selectTeamsLength);

    useEffect(() => {
        dispatch(fetchTeams());
    }, []);

    return (
        <CardMy>
            {loading ? (
                <Loader />
            ) : (
                <>
                    <Flex paddingBottom="16px" alignItems="center" justifyContent="space-between">
                        <Text color="gray.900" fontSize="24px" fontWeight={700} lineHeight={1} letterSpacing="-0.48px">
                            Teams
                            <Text color="gray.500" as="span">
                                &nbsp;{teams}
                            </Text>
                        </Text>
                        <CreateTeamDialog />
                    </Flex>
                    <TeamTable />
                </>
            )}
        </CardMy>
    );
};

export default Team;
